var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 018-8h48a8 8 0 018 8v48a8 8 0 01-8 8H8a8 8 0 01-8-8V8z",
    fill: "#105ED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.016c0-1.113.903-2.016 2.016-2.016H48a2 2 0 012 2v31.984A2.016 2.016 0 0147.984 50C29.215 50 14 34.785 14 16.016z",
    fill: "#FDFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoWhite);
export default __webpack_public_path__ + "static/media/new_logo_white.98b424561ff0bc1744e2bf2985cfa376.svg";
export { ForwardRef as ReactComponent };